module.exports = __webpack_public_path__ + "img/newsExperience1.2958ac72.png";